import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { initAxios } from './plugins/axios';
import { initCaptions, caption } from '@/filters/caption';
import { AgGridVue } from "ag-grid-vue";
import "@/styles/_app.scss";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

initCaptions('en');
initAxios(store, router);

Vue.config.productionTip = false
Vue.filter('caption', caption);
Vue.component("ag-grid-vue", AgGridVue);

// Sentry.init({
//   Vue,
//   dsn: "https://f4e6988cc0fe4f6b862d41ed6b82b2e1@bug.binary.ink/3",
//   // integrations: [
//   //   new BrowserTracing({
//   //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//   //     tracingOrigins: ["localhost", "my-site-url.com", /^\//],
//   //   }),
//   // ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
